"use client";

import { useGlobal } from "@/app/providers/use-global";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import LoginCard from "../login-card";

const LoginDialog = () => {
  const { isLoginDialogOpen, setIsLoginDialogOpen, isUserLoggedIn } =
    useGlobal();

  return (
    <Dialog
      open={isLoginDialogOpen && !isUserLoggedIn}
      onOpenChange={setIsLoginDialogOpen}
    >
      <DialogContent disableCloseIcon className="max-w-[500px]">
        <DialogHeader className="items-center w-auto">
          <DialogTitle className="text-center mb-7">
            Login to continue chatting
          </DialogTitle>
          <LoginCard />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default LoginDialog;
